define('app-FindByProductCode/main',['./settings', './viewModel', 'text!./view.html', '../app/ui/dialog', 'knockout'], function (settings, ViewModel, view, dialog, ko) {
    return {
        run: function () {
            var self = this;
            var link = $(settings.link);
            if (link.length === 0) {
                window.log('Find by product code link not found. Find by product code will not be available.');
                return;
            }

            window.log('Loading find by product code.');

            self.find = function (productCode) {
                var body = $('<div />');
                body.append(view);

                var viewModel = new ViewModel(productCode);
                ko.applyBindings(viewModel, $(body).find(settings.container)[0]);
                dialog.show('Find by holiday or cruise code', body);
            };

            //aks - D14444 : Instead of .click event use .on 
            $('.holidayCodeInner').on('click', '#lnkFindByProductCode', function (e) {
                e.preventDefault();
                var body = $('<div />');
                body.append(view);

                var viewModel = new ViewModel('');
                ko.applyBindings(viewModel, $(body).find(settings.container)[0]);
                dialog.show('Find by holiday or cruise code', body);
                $('#productCode').focus();
            });

            window.loadedModules('Find by product code');
        }
    };
});
